"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const applicationinsights_react_js_1 = require("@microsoft/applicationinsights-react-js");
const AppInsights_1 = require("../AppInsights");
const styled_components_1 = require("../styled-components");
const ErrorMessage = styled_components_1.styled.span `
  color: ${(p) => p.theme.error};
`;
/**
 * This component is a wrapper for any other component which might throw an error.
 * It will only render if an error occurs in a descendent.
 */
const ErrorBoundary = ({ children }) => {
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    return (react_1.default.createElement(applicationinsights_react_js_1.AppInsightsErrorBoundary, { appInsights: AppInsights_1.reactPlugin, onError: () => (react_1.default.createElement(ErrorMessage, { "data-test-id": "ErrorMessage" }, t `message-componentError`)) },
        react_1.default.createElement(react_1.default.Fragment, null, children)));
};
exports.ErrorBoundary = ErrorBoundary;
//# sourceMappingURL=index.js.map